import { render, staticRenderFns } from "./airHistory.vue?vue&type=template&id=a15db54a&"
import script from "./airHistory.vue?vue&type=script&lang=js&"
export * from "./airHistory.vue?vue&type=script&lang=js&"
import style0 from "./airHistory.vue?vue&type=style&index=0&id=a15db54a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports